import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboCliente`, method: 'GET', body: null, token: token})
}
